import React from 'react';
import { Box } from '@leagueplatform/genesis-core';

export interface TableRowProps {
  colSpan: number;
  children: React.ReactNode;
  /** Additional CSS styles */
  css?: React.ComponentProps<typeof Box>['css'];
}

/**
 * Shared table row component that spans the full width of a table.
 * Commonly used for loading states, empty states, and expanded content.
 */
export const TableRow: React.FC<TableRowProps> = ({
  colSpan,
  children,
  css,
}) => (
  <Box as="tr">
    <Box
      as="td"
      colSpan={colSpan}
      css={{
        textAlign: 'center',
        padding: '$two',
        ...css,
      }}
    >
      {children}
    </Box>
  </Box>
);
